export const coreVersion = "4.1.4";
export const VxeCore = {
    coreVersion,
    uiVersion: '',
    tableVersion: ''
};
